import React from 'react';
import { observer } from 'mobx-react';
import type CreateShipmentQuoteAppManager from 'apps/shipmentQuote/appManager';
import { Banner } from 'components';

interface ShipmentQuoteValidationErrorsProps {
  shipmentQuoteAppManager: CreateShipmentQuoteAppManager;
}

export const ShipmentQuoteValidationErrors = observer(
  ({ shipmentQuoteAppManager }: ShipmentQuoteValidationErrorsProps) => {
    const {
      currencyMismatch,
      supplierMismatch,
      validUntilMismatch,
      unquotableRFQs,
      areThereInstantQuotesButNotAll,
    } = shipmentQuoteAppManager;

    const { currency, manufacturer } = shipmentQuoteAppManager.shipmentQuoteApp;

    let currencyErrorText = 'Currency was not selected in the main form.';
    if (currency) {
      currencyErrorText = `Some of the product quotes do not match the currency selected: ${currency}.`;
    }
    let supplierErrorText = 'Manufacturer was not selected in the main form';
    if (manufacturer) {
      supplierErrorText = `Some of the product quotes do not match the manufacturer selected: ${manufacturer.companyName}.`;
    }
    const validUntilErrorText =
      'Some of the "Valid Until" dates are in the past.';

    const unquotableRFQsIds = unquotableRFQs
      .map((rfq: any) => rfq.decimalId)
      .join(', ');
    const unquotableRFQsErrorText = `RFQs ${unquotableRFQsIds} are not quotable.`;
    const mixedInstantQuotesErrorText =
      'A shipment quote must have either all instant quotes or no instant quotes at all, current configuration has mixed parts.';
    return (
      <div>
        {currencyMismatch && (
          <Banner text={currencyErrorText} variant='error' />
        )}
        {supplierMismatch && (
          <Banner text={supplierErrorText} variant='error' />
        )}
        {validUntilMismatch && (
          <Banner text={validUntilErrorText} variant='error' />
        )}
        {unquotableRFQs.length > 0 && (
          <Banner text={unquotableRFQsErrorText} variant='error' />
        )}
        {areThereInstantQuotesButNotAll && (
          <Banner text={mixedInstantQuotesErrorText} variant='error' />
        )}
      </div>
    );
  },
);
